export default "__VITE_ASSET__BCAIxPAH__"